import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
	close: {
		padding: theme.spacing(0.5),
	},
}));

export default function SimpleSnackbar({ isOpen, messageData, onClose }: { isOpen: boolean, messageData: String, onClose:any }) {
	const classes = useStyles();
	const handleClose = () => {
		onClose();
	}

	return <>
		<div>
			<Snackbar
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				open={isOpen}
				autoHideDuration={3000}
				onClose={handleClose}
				ContentProps={{
					'aria-describedby': 'message-id',
				}}
				message={<span id="message-id">{messageData}</span>}
				action={[
					// <Button key="undo" color="secondary" size="small" onClick={handleClose}>
					// 	UNDO
          			// </Button>,
					<IconButton
						key="close"
						aria-label="close"
						color="inherit"
						className={classes.close}
						onClick={handleClose}
					>
						<CloseIcon />
					</IconButton>,
				]}
			/>
		</div>
	</>;
}